import Repository from './Repository';
import {AxiosResponse} from "axios";
import Slot from '@/models/slot.models'
import Book from '@/models/book.models'
import BookResult from '@/models/bookresult.models'
import {Count} from "@/models/count.models";
import NameBook from "@/models/namebook.models";
import {HenTaiKham} from "@/models/henTaiKham";

const resource = '/books';

export default new class{
    getSlots(date: Date): Promise<AxiosResponse<Slot[]>>{
        return Repository.get<Slot[]>(`${resource}/slots/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`);
    }
    getBooks(date: Date, team: string, permission: string): Promise<AxiosResponse<BookResult[]>>{
        return Repository.get<BookResult[]>(`${resource}/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}/${team}/${permission}`);
    }
    getBooksByMonth(date: Date, team: string, permission: string, selectTeam: string): Promise<AxiosResponse<BookResult[]>>{
        return Repository.get<BookResult[]>(`${resource}/month/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}/${team}/${permission}/${selectTeam}`);
    }
    getBooksByPhone(phoneNumber: string, dateFrom: number, dateTo: number): Promise<AxiosResponse<BookResult[]>>{
        return Repository.get<BookResult[]>(`${resource}/phone/${phoneNumber}/${dateFrom}/${dateTo}`);
    }
    createBook(book: Book): Promise<AxiosResponse<Book>>{
        return Repository.post<Book>(resource, book);
    }
    getById(id: number): Promise<AxiosResponse<Book>>{
        return Repository.get<Book>(`${resource}/${id}`);
    }
    updateBook(book: Book): Promise<AxiosResponse<Book>>{
        return Repository.post<Book>(`${resource}/updatebook`, book);
    }
    updateCheck(id: Number): Promise<any>{
        return Repository.post<any>(`${resource}/${id}`);
    }
    countBooks(date: Date): Promise<AxiosResponse<Count[]>>{
        return Repository.get<Count[]>(`${resource}/count/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`);
    }
    getNames(dateFrom: number, dateTo: number): Promise<AxiosResponse<NameBook[]>>{
        return Repository.get<NameBook[]>(`${resource}/name/${dateFrom}/${dateTo}`);
    }
    getBooksByName(name: string, dateFrom: number, dateTo: number): Promise<AxiosResponse<BookResult[]>>{
        return Repository.get<BookResult[]>(`${resource}/name/${name}/${dateFrom}/${dateTo}`);
    }
    getListTaiKham(dateFrom: number, dateTo: number): Promise<AxiosResponse<HenTaiKham[]>>{
        return Repository.get<HenTaiKham[]>(`${resource}/getListTaiKham/${dateFrom}/${dateTo}`);
    }
}
